import React, { useState } from 'react';
import { t } from 'i18next';
import { TbCopy } from 'react-icons/tb';
import { FiEdit3, FiTarget, FiVideo } from 'react-icons/fi';
import { CourseMonitoringModuleCard } from './course-monitoring-module-card';
import { FiInfo } from 'react-icons/fi';
import {
  CourseAbout,
  CourseAboutBody,
  CourseAboutDeadline,
  CourseAboutDescription,
  CourseAboutHeader,
  CourseAboutHeaderContainer,
  CourseAboutHeaderContent,
  CourseAboutInfos,
  CourseAboutRating,
  CourseAboutRatingText
} from '@/components/custom/course';
import { StarRatingButton, StarRatingStar, StarRatingWrapper } from '@/components/custom/star-rating';
import { Button } from '@/components/ui/button';
import { Sheet, SheetBody, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { ModuleCardWrapper } from '@/components/custom/module';
import { CardMetric, CardMetricBody, CardMetricHeader, CardMetricTitle, CardMetricValue, CardMetricWrapper } from '@/components/ui/card-metric';

export function CourseMonitoringModule({ course }) {
  const [showModal, setShowModal] = useState(false);

  const totalLessons = () => {
    const parsedItems = course?.['learning-systems']?.map(item => item.learning_system_items_total_count);

    const totalLessons = parsedItems?.reduce((sum, curr) => {
      return sum + curr;
    }, 0);

    return totalLessons;
  };

  const modules = course?.['learning-systems'];

  return (
    <CourseAbout>
      <CourseAboutHeader>
        <CourseAboutHeaderContainer>
          <CourseAboutHeaderContent>
            <CourseAboutInfos>
              <CourseAboutRating>
                <StarRatingWrapper className="w-[120px]">
                  {[...Array(5)].map((_, index) => (
                    <StarRatingButton
                      key={index}
                      rate
                      className="cursor-default px-0"
                    >
                      <StarRatingStar />
                    </StarRatingButton>
                  ))}
                </StarRatingWrapper>

                <CourseAboutRatingText>
                  <strong>{course?.rating}</strong> ({course?.['total-reviews']} {t('courses.evaluations')})
                </CourseAboutRatingText>
              </CourseAboutRating>

              <CourseAboutDeadline>
                <FiInfo size={20} />
                <span>
                  O <b>certificado do curso</b> estará disponível a partir de {new Date(course?.['finished-at']).toLocaleDateString('pt-br')}
                </span>
              </CourseAboutDeadline>
            </CourseAboutInfos>

            <CourseAboutDescription className="!mb-0">
              {course?.about}
              {course?.about?.length > 300 && '...'}

              {course?.about?.length > 300 && (
                <Button
                  variant="link"
                  className="h-auto p-0"
                  onClick={() => setShowModal(true)}
                >
                  Ver mais
                </Button>
              )}
            </CourseAboutDescription>

            <Sheet
              open={showModal}
              onOpenChange={setShowModal}
              contentClassName="modal__content--md"
            >
              <SheetContent size="md">
                <SheetHeader>
                  <SheetTitle>Sobre o curso</SheetTitle>
                </SheetHeader>
                <SheetBody>
                  <p className="mb-4">{course?.about}</p>
                </SheetBody>
              </SheetContent>
            </Sheet>
          </CourseAboutHeaderContent>
        </CourseAboutHeaderContainer>

        <CardMetricWrapper>
          <CardMetric variant="outline">
            <CardMetricHeader>
              <CardMetricTitle>Módulos</CardMetricTitle>
            </CardMetricHeader>
            <CardMetricBody>
              <CardMetricValue>
                <TbCopy /> {course?.['learning-systems']?.length}
              </CardMetricValue>
            </CardMetricBody>
          </CardMetric>

          <CardMetric variant="outline">
            <CardMetricHeader>
              <CardMetricTitle>Aulas</CardMetricTitle>
            </CardMetricHeader>
            <CardMetricBody>
              <CardMetricValue>
                <FiVideo /> {totalLessons()}
              </CardMetricValue>
            </CardMetricBody>
          </CardMetric>

          <CardMetric variant="outline">
            <CardMetricHeader>
              <CardMetricTitle>Provas e Simulados</CardMetricTitle>
            </CardMetricHeader>
            <CardMetricBody>
              <CardMetricValue>
                <FiTarget /> {course?.['exam-count']}
              </CardMetricValue>
            </CardMetricBody>
          </CardMetric>

          <CardMetric variant="outline">
            <CardMetricHeader>
              <CardMetricTitle>Atividades</CardMetricTitle>
            </CardMetricHeader>
            <CardMetricBody>
              <CardMetricValue>
                <FiEdit3 /> {course?.['activity-count']}
              </CardMetricValue>
            </CardMetricBody>
          </CardMetric>
        </CardMetricWrapper>
      </CourseAboutHeader>

      <CourseAboutBody>
        <ModuleCardWrapper>
          {modules?.map(module => {
            const moduleRequirements = module.learning_system_requirement_ids;
            const requiredModules = modules.filter(item => moduleRequirements?.includes(item.id));
            const canAccess = moduleRequirements.length === 0 || requiredModules?.every(item => item.progress > 90);

            return (
              <CourseMonitoringModuleCard
                courseId={course?.id}
                newMessage
                module={module}
                key={module.id}
                canAccess={canAccess}
              />
            );
          })}
        </ModuleCardWrapper>
      </CourseAboutBody>
    </CourseAbout>
  );
}
